import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';
import Amplify from "aws-amplify";
import awsconfig from "./awsconfigExport";
import { Auth } from 'aws-amplify'
import {isAdministratorGroupMember} from './utils/userUtils.js'

Amplify.configure(awsconfig);

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const TheLayout = React.lazy(() => import('./containers/TheLayout'));

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'));
const CompleteNewPassword = React.lazy(() => import('./views/pages/login/CompleteNewPassword'));
const Logout = React.lazy(() => import('./views/pages/logout/Logout'));
// const Register = React.lazy(() => import('./views/pages/register/Register'));
const Reset = React.lazy(() => import('./views/pages/reset/Reset'));
const ForgotPasswordVerification = React.lazy(() => import('./views/pages/reset/ForgotPasswordVerification'));
const ChangePassword = React.lazy(() => import('./views/pages/change-password/ChangePassword'));

class App extends Component {
  // mod@ccs start ---
  state = {
    isAuthenticated: false,
    isAuthenticating: true,
    user: null,
  }

  setAuthStatus = authenticated => {
    this.setState({ isAuthenticated: authenticated });
  }

  setUser = user => {
    this.setState({ user: user});
  }

  async componentDidMount(){
    try{

      const userSession = await Auth.currentSession();
      if(isAdministratorGroupMember(userSession)){
        this.setAuthStatus(true);
      }

      const user = await Auth.currentAuthenticatedUser();
      this.setUser(user);

    }catch(error){
      console.log(error);
    }

    this.setState({ isAuthenticating: false });
  }
  //mod@ccs end ---
   
  render() {
    // mod@ccs ---
    const authProps = {
      isAuthenticated : this.state.isAuthenticated,
      user: this.state.user,
      setAuthStatus: this.setAuthStatus,
      setUser: this.setUser
    };

    // useEffect(() => {
      
    // }, []);

    // const dispatch = useDispatch();
    // mod@ccs ---

    return (
      // mod@ccs start ---
      !this.state.isAuthenticating && 
      // mod@ccs end ---
      <HashRouter>
        <React.Suspense fallback={loading}>
          <Switch>
            {/* <Route exact path="/login" name="Login Page" render={props => <Login {...props} auth={authProps}/>} /> */}
            <Route exact path="/login" name="Login Page" render={props => !this.state.isAuthenticated ? <Login {...props} auth={authProps}/> : <TheLayout {...props} auth={authProps} />} />
            <Route exact path="/completeNewPassword" name="CompleteNewPassword Page" render={props => <CompleteNewPassword {...props} auth={authProps}/>} />
            {/* <Route exact path="/logout" name="Logout Page" render={props => <Logout {...props} auth={authProps}/>} /> */}
            <Route exact path="/logout" name="Logout Page" render={props => this.state.isAuthenticated ? <Logout {...props} auth={authProps}/> : <TheLayout {...props} auth={authProps} />} />
            {/* <Route exact path="/register" name="Register Page" render={props => <Register {...props} auth={authProps}/> }/> */}
            <Route exact path="/reset" name="Reset Page" render={props => <Reset {...props} auth={authProps}/>} />
            <Route exact path="/forgotPasswordVerification" name="ForgotPasswordVerification Page" render={props => <ForgotPasswordVerification {...props} auth={authProps}/>} />
            {/* <Route exact path="/changePassword" name="ChangePassword Page" render={props => <ChangePassword {...props} auth={authProps}/>} /> */}
            <Route exact path="/changePassword" name="ChangePassword Page" render={props => this.state.isAuthenticated ? <ChangePassword {...props} auth={authProps}/> : <TheLayout {...props} auth={authProps} />} />
            <Route path="/" name="Home" render={props => <TheLayout {...props} auth={authProps} />} />
          </Switch>
        </React.Suspense>
      </HashRouter>
    );
  }
}

export default App;
//export default withAuthenticator(App);